"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
exports.PANE_LEVEL_KEYS = ["country", "province", "city", "area", "town"];
exports.ADDRTREE_ROOT_NAME = "GLOBAL_MAGIC_PLANET_EARTH";
exports.ADDRTREE_ROOT_KEY = "0";
exports.ADDRTREE_ROOT_RAW_DATA = [exports.ADDRTREE_ROOT_NAME, null, exports.ADDRTREE_ROOT_NAME, exports.ADDRTREE_ROOT_NAME];
exports.CACHE_COMP_VERSION = 11;
exports.PANE_LEVELS = ["province", "city", "area", "town"];
//# sourceMappingURL=Constant.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_crui-address@0.0.80@@alicd/crui-address/lib/Constant.js
// module id = 247
// module chunks = 0